import { required } from 'vuelidate/lib/validators'
import {
  slugAsyncValidator,
  slugValidator,
  validationErrorMessages
} from '@/utils/validations/validations'
import audioguidesSlugsQuery from '@/services/gql/types/Audioguides/queries/audioguidesSlugs.gql'

export default ({ id, ctx, isNew }) => {
  const isUnique = async value => {
    return await slugAsyncValidator(value, id, audioguidesSlugsQuery, ctx, 'audioguides')
      .then(res => res)
      .catch(err => console.log(err))
  }
  return {
    title: {
      required: { validator: required, message: validationErrorMessages.required }
    },
    slug: (() => {
      if (isNew) {
        return false
      }
      return {
        required: { validator: required, message: validationErrorMessages.required },
        generalValidation: {
          validator: slugValidator,
          message: validationErrorMessages.slugGeneralMsg
        },
        isUnique: { validator: isUnique, message: validationErrorMessages.unique }
      }
    })(),
    modes: {
      required: { validator: required, message: validationErrorMessages.required }
    },
    categories: {
      required: { validator: required, message: validationErrorMessages.required }
    },
    description: {
      required: { validator: required, message: validationErrorMessages.required }
    },
    profileId: {
      required: { validator: required, message: 'Обязательное поле' }
    },
    profileType: {
      required: { validator: required, message: 'Обязательное поле' }
    }
  }
}
